import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { wsPayloadResponse } from '../user/payload';
import { tap, catchError, map } from 'rxjs/operators';
import { PlugpointEnvironment } from '../PlugpointEnvironment';
import { Guid } from 'guid-typescript';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Basic NGhNVVh4a1pYYUN1amZ1NTphQXM1VnFHUyszWXZFRiN0' })
};

@Injectable()
export class CarService {


    // private url = 'https://89.33.44.84:8443/helios/api'; //test
    // private url = 'https://manage.plugpoint.ro:8443/helios/api';
    // private url = 'https://test.plugpoint.ro:8443/helios/api';
    private url = 'https://app.plugpoint.ro:8443/helios/api';
    private token = "4a46889db102438faa83b0b8151898a6";
    public guid = true;
    constructor(
        public http: HttpClient
    ) {
        this.url = PlugpointEnvironment.endpoint;
     }
    private getGatewayAuthHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
        });
    }
     /*
         * not used
     */
    getAllFleetCars(): Observable<wsPayloadResponse> {
        if(this.guid == true){
            this.token = Guid.create().toString();
            }
        let data = {
            "getAllFleetCars" : {
                "stationVendor" : "all"
            }
        }
        var encodedData = btoa(JSON.stringify(data));
        let body = {
            "token": this.token,
            "action": "fleetCars",
            "data": encodedData
        }
        return this.http.post<wsPayloadResponse>(this.url, body, httpOptions).pipe(
            // tap(_ => console.log("hehe")),
            catchError(this.handleError<wsPayloadResponse>()));
    }

    getVendorFleetCars(stationVendor: string,): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/cars/${stationVendor}`;
        return this.http.get<any>(url, { headers: this.getGatewayAuthHeaders() });
    }
    /*
        * not used ANYWHERE
    */
    getOneFleetCar(carId: number): Observable<wsPayloadResponse> {
        if(this.guid == true){
            this.token = Guid.create().toString();
            }
        let data = {
            "getOneFleetCar" : {
                "id" : carId
            }
        }
        var encodedData = btoa(JSON.stringify(data));
        let body = {
            "token": this.token,
            "action": "fleetCars",
            "data": encodedData
        }
        return this.http.post<wsPayloadResponse>(this.url, body, httpOptions).pipe(
            // tap(_ => console.log("hehe")),
            catchError(this.handleError<wsPayloadResponse>()));
    }

    addFleetCar(userId: string, stationVendor: string, brand: string, model: string, plateNo: string, status: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/cars/add`;
        let body = {
            requester: userId,
            stationVendor: stationVendor,
            brand: brand,
            model: model,
            plateNo: plateNo,
            status: status
        }
        return this.http.post<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

    updateFleetCar(userId: string, carId: number, stationVendor: string, brand: string, model: string, plateNo: string, status: string, km: number, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/cars/update`;
        let body = {
            requester: userId,
            id: carId,
            stationVendor: stationVendor,
            brand: brand,
            model: model,
            plateNo: plateNo,
            status: status,
            km: km
        }
        return this.http.put<any>(url, body, { headers: this.getGatewayAuthHeaders() });
    }

    /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            // console.error(error); // log to console instead


            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
